module.exports = __webpack_public_path__ + "img/ex1.f50365e2.png";